module.exports = __webpack_public_path__ + "static/media/preview.fb58aad3.jpg";